module.exports = __webpack_public_path__ + "static/media/redemption-gift-cutlery-set.f5cbba08.png";